import React from 'react';
export const Chevron = () => /*#__PURE__*/React.createElement("svg", {
  width: "11",
  height: "18",
  viewBox: "0 0 11 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2 2C4.73367 4.73367 6.26633 6.26633 9 9L2 16",
  stroke: "#247592",
  strokeWidth: "2.5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
export default Chevron;